import getEnvironment from '../helpers/getEnvironment';
import localConfig from './config/config.local';
import stgConfig from './config/config.stg';
import prodConfig from './config/config.prod';

const getConfig = () => {
	const environment = getEnvironment();

	if (environment === 'local') return localConfig;
	else if (environment === 'stg') return stgConfig;
	else if (environment === 'prod') return prodConfig;

	return localConfig;
};

const getFromLocalStorage = key => {
	const data = JSON.parse(localStorage.getItem('init'));

	if (!data)
		return {};

	return data[key] || {};
};

export default {
	app: {
		booted: false,
		toggleHamburgerMenu: false,
		featureFlags: {},
		metaData: {},
		clientEnv: getEnvironment(),
		clientApp: 'washplant',
		activeApiCalls: [],
		navigation: {},
	},

	config: getConfig(),

	pages: {},
	articles: {},
	popups: {},
	contacts: {},
	modal: {
		visible: false,
		windows: [],
	},
};
